$(document).ready(function (){

    $('body').on('click', '.neighborhoods_buildings__filters button:not(.active)', function (e){
        e.preventDefault();
        $(this).addClass('active').siblings().removeClass('active');

        const ajaxData = {
            action: 'filter_neighborhoods_apartments',
            count: $(this).parent().data('count'),
            neighborhood: $(this).parent().data('neighborhood'),
            beds: $(this).data('beds'),
        };

        $.ajax({
            url: "/wp-admin/admin-ajax.php",
            type: 'POST',
            data: ajaxData,
            dataType: 'json',
            beforeSend: function() {
                $('.neighborhoods_buildings__list').addClass('loading');
            },
            success: function(response) {
                if (response.success) {
                    $('.neighborhoods_buildings__list').html(response.data.html);
                    initPropertyCardSliders();
                }
            },
            complete: function (){
                $('.neighborhoods_buildings__list').removeClass('loading');
            }
        });
    })
});